import React, { useRef } from "react";

import { IconButton } from "@mui/material";
import { AppMenu, AppMenuProps } from "Components/AppMenu";
import { ResourceMenuHandles } from "Components/AppMenu/AppMenu";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { AppSwitch } from "Components/Generic/AppSwitch";
import { Setting2 as IconSettings } from "iconsax-react";
import { Filters } from "Models/shipeezi.table";
import { useTranslation } from "react-i18next";
import { ResourceViewerOptions } from "Util/enums";

const CHECK = require("Assets/icons/check.svg");

export const DiaryHeaderSettingsMenu = () => {
  const { t: translate } = useTranslation();
  const {
    selectedOption,
    setSelectedOption,

    collapseAllOrdersTasks,
    expandAllOrdersTasks,
    collapseAllTeams,
    expandAllTeams,
    tasks,
    crews,
    showUnavailableItems,
    setShowUnavailableItems,
    showEmptyOrdersTasks,
    setShowEmptyOrdersTasks,
    showEmptyTeams,
    setShowEmptyTeams,
    setActiveFilters,
    setActiveSearches,
  } = useOperationDespatchContext();
  const settingsMenuRef = useRef<ResourceMenuHandles | null>(null);

  const createFilterEmptyState = (): Filters => ({});

  const changeViewPerspective = (newActivePerspective: ResourceViewerOptions) => {
    setActiveFilters(() => ({
      equipmentsFilters: createFilterEmptyState(),
      memberFilters: createFilterEmptyState(),
      storageBoxFilters: createFilterEmptyState(),
      teamsFilters: createFilterEmptyState(),
    }));
    setActiveSearches(() => ({
      equipmentSearch: "",
      memberSearch: "",
      storageBoxSearch: "",
      teamSearch: "",
    }));
    setSelectedOption(newActivePerspective);
  };

  const actions: AppMenuProps["actions"] = [
    {
      label: translate("viewOptions"),
      isSubHeader: true,
    },
    {
      label: translate("showItemsUnavailable"),
      isDisabled: false,
      autoClose: false,
      rightContent: (
        <AppSwitch
          checked={showUnavailableItems}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setShowUnavailableItems(event.target.checked)
          }
        />
      ),
    },
    {
      label:
        selectedOption === ResourceViewerOptions.ORDER
          ? translate("showEmptyOrdersTasks")
          : translate("showEmptyTeams"),
      onClick: () =>
        selectedOption === ResourceViewerOptions.ORDER
          ? setShowEmptyOrdersTasks(!showEmptyOrdersTasks)
          : setShowEmptyTeams(!showEmptyTeams),
      rightContent: (selectedOption === ResourceViewerOptions.ORDER
        ? showEmptyOrdersTasks
        : showEmptyTeams) && <img src={CHECK} alt="Checkmark" style={{ marginLeft: "auto" }} />,
      autoClose: false,
    },
    {
      label:
        selectedOption === ResourceViewerOptions.ORDER
          ? translate("collapseOrdersTasks")
          : translate("collapseTeams"),
      isDisabled: selectedOption === ResourceViewerOptions.ORDER ? !tasks?.length : !crews?.length,
      onClick:
        selectedOption === ResourceViewerOptions.ORDER ? collapseAllOrdersTasks : collapseAllTeams,
      autoClose: false,
    },
    {
      label:
        selectedOption === ResourceViewerOptions.ORDER
          ? translate("expandOrdersTasks")
          : translate("expandTeams"),
      isDisabled: selectedOption === ResourceViewerOptions.ORDER ? !tasks?.length : !crews?.length,
      onClick:
        selectedOption === ResourceViewerOptions.ORDER ? expandAllOrdersTasks : expandAllTeams,
      autoClose: false,
    },
    {
      isDivider: true,
    },
    {
      label: translate("boardDisplay"),
      isSubHeader: true,
    },
    {
      label: translate("organiseByTask"),
      onClick: () => {
        changeViewPerspective(ResourceViewerOptions.ORDER);
      },
      rightContent: selectedOption === ResourceViewerOptions.ORDER && (
        <img src={CHECK} alt="Checkmark" style={{ marginLeft: "auto" }} />
      ),
      autoClose: false,
    },
    {
      label: translate("organiseByTeam"),
      onClick: () => {
        changeViewPerspective(ResourceViewerOptions.TEAM);
      },
      rightContent: selectedOption === ResourceViewerOptions.TEAM && (
        <img src={CHECK} alt="Checkmark" style={{ marginLeft: "auto" }} />
      ),
      autoClose: false,
    },
  ] as AppMenuProps["actions"];

  return (
    <React.Fragment>
      <IconButton
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          settingsMenuRef.current?.open(event.currentTarget)
        }
        color="primary"
        sx={{
          borderWidth: "1px !important",
          borderColor: "currentColor !important",
          borderStyle: "solid !important",
        }}
      >
        <IconSettings size={20} />
      </IconButton>
      <AppMenu
        ref={settingsMenuRef}
        elevation={2}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        size="large"
        actions={actions}
      />
    </React.Fragment>
  );
};
